// src/store.ts
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/authSlice";
import orderSliceReducer from "../slices/kontrolEdge/orderSlice";
import sideMenuReducer from "../slices/sideMenuSlice";
import userProfileReducer from "../slices/userProfileSlice";
import portReducer from "../slices/kontrolEdge/portSlice";
import productReducer from "../slices/productSlice"
import connectionReducer from "../slices/kontrolEdge/connectionSlice"
import datacenterReducer from "../slices/kontrolEdge/datacenterSlice"
import selectionReducer from "../slices/tenantSlice";
import userEditorReducer from "../slices/userEditorSlice";
import userListReducer from "../slices/usersListSlice";

// Importamos redux-persist
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const rootReducer = combineReducers({
  auth:        authReducer,
  order:       orderSliceReducer,
  sideMenu:    sideMenuReducer,
  userProfile: userProfileReducer,
  port:        portReducer,
  product:     productReducer,
  connection:  connectionReducer,
  datacenter:  datacenterReducer,
  selection:   selectionReducer,
  userEditor: userEditorReducer,
  userList: userListReducer,
});


// Config de persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["selection"], //slice saved
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
